import { Props_SnippetContentThumbnails } from "./ContentThumbnails.props"
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import SwiperControls, { swiperNavigationOptions, swiperPaginationOptions } from '../Shared/SwiperControls/SwiperControls';
import SnippetLink from '../Shared/Link/Link'

const SnippetContentThumbnails = (props: Props_SnippetContentThumbnails) => {
    const { heading, layout, mobile_carousel, repeatable_card } = props
    const showCarousel = mobile_carousel.enabled?.value === 'true';
    const classHeadingVisibility: string = heading.visibility?.value ? ` snippet-content-thumbnails__heading--${heading.visibility.value}` : ''
    const classCarouselEnabled: string = showCarousel ? ' snippet-content-thumbnails__grid--carousel' : '';


    return (
        <section className="snippet-content-thumbnails">
            <div className="snippet-content-thumbnails__container">
                <h2 className={`snippet-content-thumbnails__heading ${classHeadingVisibility}`}>{heading.content.value}</h2>
                <div className={`snippet-content-thumbnails__grid snippet-content-thumbnails__grid--${layout.height?.value}${classCarouselEnabled}`}>
                    {showCarousel ? 
                        (
                            <div className="snippet-content-thumbnails__carousel-wrapper">
                                <Swiper
                                    className="snippet-brands-carousel__swiper"
                                    modules={[Navigation, Pagination, A11y]}
                                    navigation={{
                                        ...swiperNavigationOptions,
                                        prevEl: `.swiper-navigation__button-prev-snippet-content-thumbnails`,
                                        nextEl: `.swiper-navigation__button-next-snippet-content-thumbnails`,
                                    }}
                                    pagination={{
                                        ...swiperPaginationOptions,
                                        el: `.swiper-pagination-snippet-content-thumbnails`,
                                    }}
                                    spaceBetween={6}
                                    slidesPerView={1}
                                    breakpoints={{
                                        991: {
                                            slidesPerView: 3,
                                            navigation: false,
                                            pagination: false
                                        }
                                    }}
                                >
                                    {repeatable_card?.map((card, index) => (
                                        <SwiperSlide key={index} className="snippet-content-thumbnails__card">
                                            <img
                                                loading="lazy"
                                                src={card.image?.value}
                                                className="snippet-content-thumbnails__card-image"
                                                alt={card.imageAltText?.value}
                                                width={428}
                                                height={layout.height?.value === 'tall' ? 508 : 284}
                                            />
                                                <div className="snippet-content-thumbnails__card-content-overlay">
                                                    {card.cardHeading?.value &&
                                                    <h3 className="snippet-content-thumbnails__card-heading">{card.cardHeading.value}</h3>
                                                    }
                                                    <SnippetLink
                                                        linkStyles={card.linkStyle?.value}
                                                        className="snippet-content-thumbnails__card-link"
                                                        url={card.linkHref?.value}
                                                        target={card.linkTarget?.value}
                                                    >
                                                        {card.linkContent?.value}
                                                    </SnippetLink>
                                                </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                                <SwiperControls 
                                    uniqueId="snippet-content-thumbnails"
                                    className="snippet-content-thumbnails__navigation"
                                />
                            </div>
                        ) : (
                            <>
                                {repeatable_card.map((card, index) => (
                                    <div key={index} className="snippet-content-thumbnails__card">
                                        <img
                                            loading="lazy"
                                            src={card.image?.value}
                                            className="snippet-content-thumbnails__card-image"
                                            alt={card.imageAltText?.value}
                                            width={427}
                                            height={layout.height?.value === 'tall' ? 508 : 284}
                                        />
                                        <div className="snippet-content-thumbnails__card-content-overlay">
                                            {card.cardHeading?.value &&
                                                <h3 className="snippet-content-thumbnails__card-heading">{card.cardHeading.value}</h3>
                                            }
                                        </div>
                                    </div>
                                ))}
                            </>
                        )
                    }
                </div>
            </div>
        </section>
    )
}

export default SnippetContentThumbnails